export default __webpack_public_path__ + "static/media/TECH21.8d03956e.svg";